/* knowledge-card-user-row.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "style"];
import "./knowledge-card-user-row.compiled.css";
import { forwardRef } from 'react';
import { ax, ix } from "@compiled/react/runtime";
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl-next';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { ProfileCardTrigger } from '@atlaskit/profilecard';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { messages } from '../../messages';
import { useMeaningfulHover } from '../../v2/common/hooks/use-meaningful-hover';
import { KnowledgeCardsRowRefresh } from '../knowledge-cards-row';
import { PersonCard } from '../person-knowledge-card/person-card';
import { KnowledgeCardsIntentType, KnowledgeCardsRowType } from '../types';
import { useTeamsAppLinks } from '../use-teams-app-links';
import { createProfileClient, trimARI } from '../util';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-unsafe-style-overrides
var CardContainer = forwardRef(function (_ref, __cmplr) {
  var _ref$as = _ref.as,
    C = _ref$as === void 0 ? TooltipPrimitive : _ref$as,
    __cmpls = _ref.style,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1bsb1ijo _4t3il3i9", __cmplp.className])
  }));
});
if (process.env.NODE_ENV !== 'production') {
  CardContainer.displayName = 'CardContainer';
}
export var KnowledgeCardUserRow = /*#__PURE__*/React.memo(function (_ref2) {
  var user = _ref2.item,
    onClickCallback = _ref2.onClickCallback;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useTeamsAppLinks = useTeamsAppLinks({
      type: KnowledgeCardsIntentType.PERSON,
      currentUserId: user.accountId || '',
      cloudId: commonAttributes.cloudId
    }),
    toUser = _useTeamsAppLinks.toUser;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var userUrl = "/people/".concat(trimARI(user.accountId || ''));
  var handleUserClick = function handleUserClick(e) {
    if (fg('platform-adopt-teams-nav-config')) {
      toUser(user.accountId || '').onNavigate(e);
    } else {
      window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
    }
  };
  var profileClient = useMemo(function () {
    return createProfileClient(commonAttributes.cloudId);
  }, [commonAttributes.cloudId]);
  var _useMeaningfulHover = useMeaningfulHover({
      elementType: 'collaborator',
      hoverCardSelector: '[data-testid="profilecard"]'
    }),
    handleHoverStart = _useMeaningfulHover.handleHoverStart,
    handleHoverLeave = _useMeaningfulHover.handleHoverLeave;
  if (fg('kd_platform_person_cards')) {
    return /*#__PURE__*/React.createElement(ProfileCardTrigger, {
      userId: trimARI(user.accountId || ''),
      resourceClient: profileClient,
      actions: [{
        label: formatMessage(messages.knowledge_cards_person_hover_profile_link),
        link: toUser(user.accountId || '').href,
        callback: function callback(e) {
          onClickCallback === null || onClickCallback === void 0 || onClickCallback();
          toUser(user.accountId || '').onNavigate(e);
        }
      }],
      ariaLabel: user.name,
      position: "bottom-end"
    }, /*#__PURE__*/React.createElement(Box, {
      onMouseEnter: fg('kd_meaningful_hover') ? handleHoverStart : undefined,
      onMouseLeave: fg('kd_meaningful_hover') ? handleHoverLeave : undefined
    }, /*#__PURE__*/React.createElement(KnowledgeCardsRowRefresh, {
      primaryText: user.name,
      secondaryText: !!user.title || !!user.department ? [user.title, user.department].filter(function (str) {
        return !!str;
      }).join(', ') : '',
      pictureUrl: user.picture || '',
      type: KnowledgeCardsRowType.PERSON,
      onClick: function onClick(e) {
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        handleUserClick(e);
      }
    })));
  }
  return /*#__PURE__*/React.createElement(Box, {
    onMouseEnter: fg('kd_meaningful_hover') ? handleHoverStart : undefined,
    onMouseLeave: fg('kd_meaningful_hover') ? handleHoverLeave : undefined
  }, /*#__PURE__*/React.createElement(Tooltip, {
    key: user.accountId,
    position: "bottom-end"
    // @ts-ignore -- `styled(TooltipPrimitive)` is invalid for `component` (ignored as it fails types in Jira and should in Platform)
    ,
    component: CardContainer,
    content: /*#__PURE__*/React.createElement(PersonCard, {
      key: user.accountId,
      name: user.name,
      profilePicUrl: user.picture || '',
      accountId: user.accountId || '',
      jobTitle: user.title || '',
      profileUrl: user.url || userUrl,
      email: user.email || ''
    })
  }, function (triggerProps) {
    return /*#__PURE__*/React.createElement(KnowledgeCardsRowRefresh, {
      primaryText: user.name,
      secondaryText: !!user.title || !!user.department ? [user.title, user.department].filter(function (str) {
        return !!str;
      }).join(', ') : '',
      pictureUrl: user.picture || '',
      type: KnowledgeCardsRowType.PERSON,
      triggerProps: triggerProps,
      onClick: function onClick(e) {
        onClickCallback === null || onClickCallback === void 0 || onClickCallback();
        handleUserClick(e);
      }
    });
  }));
});